import React, { useEffect, useMemo } from "react";
import moment from "moment";
import { cacheService, orderService } from "../../../Core/Api/services";
import TableSkeleton from "../../../Components/Table/TableSkeleton";
import OrderItemTable from "../../../Components/Table/OrdersTable/orders-items-table";
import OrderItemPanel from "../../../Components/Panels/OrderItemPanel/order-item-panel";
import { useOutletContext } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { GetCurrentOrders, StoreOrders } from "../../../Redux/Reducers/redux-slice-object-orders";
import { PlatformMode } from "../../../Core/Api/Types/platform-mode";
import OrderDeliveryTable from "../../../Components/Adam/adam-orders-delivery-table";
import { DateRange } from "@mui/lab";
import dayjs, { Dayjs } from "dayjs";
import { DbOrderItemInfos } from "../../../Core/Api/Types/db-order-item-infos";
import { useAppSelector } from "../../../Redux/redux-store";

function OrderItemDetails() {
  const [isLoading, setLoading] = React.useState(true);
  const [openPanelOrderItem, setOpenPanelOrderItem] = React.useState(false);
  const [selectedOrderItemId, setSelectedOrderItemId] = React.useState<number>(-1);
  const rows = useAppSelector(GetCurrentOrders);
  const [dateRange, setDateRange] = React.useState<DateRange<Dayjs>>([
    dayjs(moment().add(-20, "d").format("YYYY-MM-DD")),
    dayjs(moment().add(1, "d").format("YYYY-MM-DD")),
  ]);

  const dispatch = useDispatch();
  // Outlet context used to pass props to parent DashboardLayout through react router dom
  const { selectedItems, setSelectedItems } = useOutletContext<{
    setSelectedItems: React.Dispatch<React.SetStateAction<DbOrderItemInfos[]>>;
    selectedItems: DbOrderItemInfos[];
  }>();

  const hidePanelOrder = () => {
    setOpenPanelOrderItem(false);
  };
  const showPanelOrder = (e: any) => {
    hidePanelOrder();
    setSelectedOrderItemId(e);
    setOpenPanelOrderItem(true);
  };

  // Fetching data
  React.useEffect(() => {
    setLoading(true);
    const start = moment(new Date(dateRange[0]?.toString() || "")).format("YYYY-MM-DD");
    const end = moment(new Date(dateRange[1]?.toString() || "")).format("YYYY-MM-DD");

    // Todo: make a call more restrictive
    orderService.GetItemsListByDate(start, end).then(function (response) {
      dispatch(StoreOrders(response.items));
      setLoading(false);
    });
  }, [dateRange]);

  return (
    <>
      {cacheService.GetPlatformMode() === PlatformMode.Adam ? (
        <OrderDeliveryTable
          isLoading={isLoading}
          showPanelOrder={showPanelOrder}
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          dateRange={dateRange}
          data={rows}
          setDateRange={setDateRange}
        />
      ) : (
        <OrderItemTable
          isLoading={isLoading}
          orders={rows}
          showPanelOrder={showPanelOrder}
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
        />
      )}
      <OrderItemPanel open={openPanelOrderItem} onClose={hidePanelOrder} itemId={selectedOrderItemId} />
    </>
  );
}

export default OrderItemDetails;
